/**
 * 회사 설정과 알림 설정 시드 — `site_config` 한 행과 `notification_setting` 몇 행.
 *
 * site_config 는 사무소 하나당 한 행뿐이다. 알림 설정은 행이 없는 종류를 켜진 것으로 보므로
 * 끄거나 역할을 더한 종류만 깔아 둔다.
 */
import type { NotificationKind, SiteConfig } from "@/types";

export const siteConfig: SiteConfig = {
  daily_deadline: "23:30:00",
  daily_reminder_at: "18:30:00",
  daily_image_limit: 3,
  work_start: "09:00:00",
  work_end: "18:00:00",
  lunch_start: "12:00:00",
  lunch_end: "13:00:00",
  standard_daily_hours: 8,
  standard_monthly_hours: 174,
  weekly_overtime_limit: 12,
  weekly_total_limit: 52,
  vacation_auto_approve_days: 1,
  vacation_notice_days: 7,
  vacation_notice_prev_week: false,
  vacation_cancel_weeks: 1,
  vacation_grant_basis: "hire_date",
  vacation_carryover_days: 5,
  money_display_unit: "won",
  updated_at: "2026-10-01T09:30:00+09:00",
};

/** 사람마다 끈 알림 — `user_notification_setting`. 행이 없는 종류는 켜진 것으로 본다. */
export const userNotificationSettings: {
  user_id: string;
  kind: NotificationKind;
  is_enabled: boolean;
}[] = [{ user_id: "u-staff", kind: "report_ready", is_enabled: false }];
